// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__2lBpq","heading":"Styles_heading__11QKl","content":"Styles_content__3FCnW","inner":"Styles_inner__2dd9P"};